import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { DatePickerWithTenorNext } from '@/components/ui/DatePickerWithTenorNext.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import {
  selectTargetAccumulatorScheduleData,
  selectTargetAccumulatorScheduleFieldValidation,
  selectTargetAccumulatorScheduleTable,
} from '@/store/targetAccumulator/selectors.ts';
import type { AccumulatorScheduleLine } from '@/store/targetAccumulator/state.ts';

const PaymentDate = ({ legId }: { legId: string }) => {
  const { sgwtWebAnalytics } = useSgwtWidgets();
  const tileId = useTargetAccumulatorTileId();
  const paymentDate = useAppSelector(
    (state) => selectTargetAccumulatorScheduleTable(state, tileId, legId)?.paymentDate,
  );
  const isModified = useAppSelector(
    (state) =>
      selectTargetAccumulatorScheduleData(state, tileId).scheduleCustomFields?.[legId]?.includes('PaymentDate') ??
      false,
  );
  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();
  const { validation } = useAppSelector((state) =>
    selectTargetAccumulatorScheduleFieldValidation(state, tileId, legId, 'paymentDateString'),
  );

  const handlePaymentDate = (value: string) => {
    sgwtWebAnalytics?.trackEvent('Target Accumulator', 'Schedule payment date changed', value ?? 'null');

    return checkTargetAccumulatorWithTradeCapture({
      schedule: { [legId]: { paymentDate: isDefined(value) ? value : null } as AccumulatorScheduleLine },
    });
  };

  return (
    <div style={{ maxWidth: '8rem' }}>
      <TradeCaptureValidationWrapper validation={validation}>
        <DatePickerWithTenorNext
          color={isModified ? 'info' : undefined}
          date={isDefined(paymentDate) ? paymentDate : undefined}
          onChange={handlePaymentDate}
          data-e2e="paymentDate"
          allTenors={[]}
        />
      </TradeCaptureValidationWrapper>
    </div>
  );
};

export default PaymentDate;
